<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <section id="pay-section" class="py-2 mobile-container">
            <div class="bg-light p-4" v-if="serverError">
                <div class="text-danger text-center">{{ serverError }}</div>
            </div>
            <div class="bg-light p-4" v-if="paymentAlreadyMade">
                <div class="text-danger text-center">
                    Betalingen er allerede foretaget. Din booking vil snart blive opgraderet. Tak for din tillid!
                </div>
            </div>
            <div id='rp_container' style="width: 100%; height: 730px;"></div>
        </section>
        <back-section :url="prevUrl" type="1"></back-section>
    </div>

</template>

<script>
import BackSection from "./reusable/BackSection.vue";
import FlashError from "./reusable/FlashError.vue";
export default {
    name: "CmfPaymentPage",
    components: {FlashError, BackSection},
    props: {
        booking: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        applyChangesUrl: {type: String, required: true},
        logResultsUrl: {type: String, required: true},
        sessionId: {type: String, required: false, default: ''},
        serverError: {type: String, required: false, default: ''},
        paymentId: {type: String, required: false, default: ''},
        paymentAlreadyMade: {type: Boolean, required: false, default: false},
        addressTypeDropoff: {type: Number, required: false, default: 0},
        addressTypePickup: {type: Number, required: false, default: 1},
    },
    data() {
        return {}
    },
    mounted() {
        if (!this.paymentAlreadyMade) {
            this.openPaymentWindow();
        }
    },
    methods: {
        goNext(transactionId) {
            axios.post(this.applyChangesUrl, {
                    payment: {key: 'payment', completed: true, transactionId: transactionId},
                    handleChanges: true
                })
                .then((response) => {
                    window.location.href = this.nextUrl;

                }).catch(error => {
                this.$refs.flashError.flashError(error);
            });
        },
        openPaymentWindow() {
            if (this.sessionId && !this.serverError) {
                let rp = new Reepay.EmbeddedCheckout(this.sessionId, {html_element: 'rp_container'});

                const events = {
                    Accept: Reepay.Event['Accept'],
                    Error: Reepay.Event['Error'],
                    Cancel: Reepay.Event['Cancel'],
                    Close: Reepay.Event['Close']
                };

                for (let key in events) {
                    rp.addEventHandler(events[key], (data) => {
                        this.logResults(key, data);
                    });
                }
            }
        },
        logResults(status, data) {
            const addressType = this.paymentId.includes('-pickup-') ? this.addressTypePickup : this.addressTypeDropoff;
            axios.post(this.logResultsUrl, {
                    payment: data,
                    status: status,
                    addressType: addressType,
                })
                .then((response) => {
                    console.log(response);
                    let transactionId = (response['data'] && response['data']['transactionId']) ?
                        response['data']['transactionId'] :
                        '';
                    if (status === 'Accept') {
                        this.goNext(transactionId);
                    }
                }).catch(error => {
                console.error(error.response);
            });
        },
    },
}

</script>

<style scoped>

</style>
